import { render, staticRenderFns } from "./2-2.Query.vue?vue&type=template&id=566876fd&scoped=true"
import script from "./2-2.Query.vue?vue&type=script&lang=js"
export * from "./2-2.Query.vue?vue&type=script&lang=js"
import style0 from "./2-2.Query.vue?vue&type=style&index=0&id=566876fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566876fd",
  null
  
)

export default component.exports